import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const AssetsTableHeaders = [
  { title: '#ID', align: 'start', key: 'id', placeholder: '00000' },
  { title: 'Name', align: 'start', key: 'name', sortable: false, placeholder: 'Asset name' },
  {
    title: 'ID',
    align: 'start',
    key: 'uniqueIdentifier',
    sortable: false,
    placeholder: 'Identifier',
  },
  { title: 'Type', align: 'start', key: 'type', sortable: false, placeholder: 'Type' },
  { title: 'Actions', align: 'end', key: 'actions', sortable: false },
] as const satisfies readonly TableHeaderSpec[]
